import styled from "styled-components"

import { TextField } from "@minuthq/meatball-ui-react"

import { clientCredentialLabelsMap } from "src/data/integrations/logic/integrations"
import { TIntegration } from "src/data/integrations/types/integrationTypes"
import { INTEGRATION_SECRET_DEFAULT } from "src/data/integrations/types/integrationTypes"
import { MCircularProgress } from "src/ui/MCircularProgress/MCircularProgress"
import { spacing } from "src/ui/spacing"

type ConnectContentProps = {
  integration: TIntegration
  secret: string
  setSecret: (value: string) => void
  multiSecret: Map<string, string>
  setMultiSecret: (value: Map<string, string>) => void
  clientId: string
  setClientId: (value: string) => void
  postIntegrationSecret: { reset: () => void }
  postIntegrationMultiSecret: { reset: () => void }
  postClientCredentials: { reset: () => void }
}

export function ConnectContent({
  integration,
  secret,
  setSecret,
  multiSecret,
  setMultiSecret,
  clientId,
  setClientId,
  postIntegrationSecret,
  postIntegrationMultiSecret,
  postClientCredentials,
}: ConnectContentProps) {
  switch (integration.auth.type) {
    case "SECRET":
      return (
        <Content>
          <TextField
            label={integration.auth.secret_description}
            value={secret}
            onChange={(val) => {
              postIntegrationSecret.reset()
              setSecret(val)
            }}
          />
        </Content>
      )

    case "MULTI_SECRET":
      return (
        <MultiSecretContent>
          {integration.auth.multi_secret?.map(({ id, description }) => (
            <TextField
              key={id}
              label={description}
              value={multiSecret.get(id ?? INTEGRATION_SECRET_DEFAULT) || ""}
              onChange={(value) => {
                postIntegrationMultiSecret.reset()
                const newMultiSecret = new Map(multiSecret)
                newMultiSecret.set(id ?? INTEGRATION_SECRET_DEFAULT, value)
                setMultiSecret(newMultiSecret)
              }}
            />
          ))}
        </MultiSecretContent>
      )

    case "OAUTH2_CLIENT_CREDENTIALS":
      return (
        <Content>
          <TextField
            label={
              clientCredentialLabelsMap[integration.integration_identifier]
                ?.clientIdLabel ?? "Client id"
            }
            value={clientId}
            onChange={(val) => {
              postClientCredentials.reset()
              setClientId(val)
            }}
          />
          <TextField
            label={
              clientCredentialLabelsMap[integration.integration_identifier]
                ?.clientSecretLabel ?? "Client secret"
            }
            value={secret}
            onChange={(val) => {
              postClientCredentials.reset()
              setSecret(val)
            }}
          />
        </Content>
      )
    case "SEAM_CONNECT_WEBVIEW":
    case "OAUTH2":
      return (
        <MCircularProgress style={{ display: "block", margin: "24px auto" }} />
      )

    default:
      throw new Error(`Unexpected type ${integration.auth.type}`)
  }
}

const Content = styled.div`
  padding: ${spacing.M} 0;
  display: grid;
  grid-gap: ${spacing.M};
`

const MultiSecretContent = styled.div`
  margin: ${spacing.S} 0 ${spacing.M} 0;
  display: grid;
  gap: ${spacing.M};
`
